import { Hint, Spacer } from '@lokalise/louis';

import useSelector from '@app/hooks/useSelector';

import { getAvailableProjects } from '../../reducers/downloadData/selectors';
import type { ProjectId } from '../../types';
import ExportAccordion from '../ExportAccordion';
import IncludeOtherProjectStringsInput from './IncludeOtherProjectStringsInput';

interface IncludeOtherProjectStringsInputContainerProps {
    value: readonly ProjectId[];
    onChange: (value: readonly ProjectId[]) => void;
    projectId: string;
}

const IncludeOtherProjectStringsInputContainer = ({
    value,
    onChange,
    projectId,
}: IncludeOtherProjectStringsInputContainerProps) => {
    const availableProjects = useSelector(getAvailableProjects);

    const options = availableProjects.map(({ id, name }) => ({ value: id, label: name }));

    return (
        <ExportAccordion
            heading={
                <>
                    <b>Include other Project strings </b>
                    <Hint placement="top">
                        Select projects which keys and translations should be added to this export. Useful if you share
                        same keys over several projects, for example country names. Note, Lokalise will not filter out
                        duplicate keys and only include languages selected above (if present in projects being
                        included).
                    </Hint>
                </>
            }
            name="otherProjectStrings"
            projectId={projectId}
        >
            <Spacer top={3}>
                <IncludeOtherProjectStringsInput value={value} options={options} onChange={onChange} />
            </Spacer>
        </ExportAccordion>
    );
};

export default IncludeOtherProjectStringsInputContainer;
